import { parsePromotionsResponse } from './parse-promotions';
import type { PromotionEntry } from '@common/types/promotions';
import defaultBadges from '../../../../../badges.example.json';

/** Local dev only — when BADGES_URL is unset. Dev/prod use remote badges.json via BADGES_URL. */
export function usesLocalPromotionsSource(): boolean {
  return !process.env.BADGES_URL;
}

export function getDefaultPromotions(): PromotionEntry[] {
  return parsePromotionsResponse(defaultBadges);
}
